/**
 * Blocking disclaimer overlay until the user accepts the terms.
 * Same pattern as tdis-dmqt-app Disclaimer.
 */

import React from "react";
import disclaimerConfig from "../config/disclaimerConfig";
import "./Disclaimer.css";

const Disclaimer = ({ onAccept }) => {
  const handleAccept = () => {
    if (onAccept) {
      onAccept();
    }
  };

  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-container">
        <div className="disclaimer-left-panel">
          <div className="disclaimer-left-content">
            {disclaimerConfig.tdisLogo && (
              <div className="disclaimer-logo-section disclaimer-tdis-section">
                <img
                  src={disclaimerConfig.tdisLogo}
                  alt="TDIS Logo"
                  className="disclaimer-tdis-logo"
                />
              </div>
            )}

            {disclaimerConfig.tamuLogo && (
              <div className="disclaimer-logo-section disclaimer-tamu-section">
                <img
                  src={disclaimerConfig.tamuLogo}
                  alt="Texas A&M University Logo"
                  className="disclaimer-tamu-logo"
                />
              </div>
            )}

            {disclaimerConfig.idrtLogo && (
              <div className="disclaimer-logo-section disclaimer-idrt-section">
                <img
                  src={disclaimerConfig.idrtLogo}
                  alt="IDRT Logo"
                  className="disclaimer-idrt-logo"
                />
              </div>
            )}

            {disclaimerConfig.footerPoweredBy && (
              <div className="disclaimer-footer">
                <p className="disclaimer-footer-text">
                  {disclaimerConfig.footerPoweredBy}
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="disclaimer-right-panel">
          <div className="disclaimer-content">
            {disclaimerConfig.welcomeText && (
              <p className="disclaimer-welcome-text">
                {disclaimerConfig.welcomeText}
              </p>
            )}
            {disclaimerConfig.welcomeTitle && (
              <h2 className="disclaimer-welcome-title">
                {disclaimerConfig.welcomeTitle}
              </h2>
            )}

            {disclaimerConfig.informationText && (
              <p className="disclaimer-information-text">
                {disclaimerConfig.informationText}
              </p>
            )}
            {disclaimerConfig.informationLink && (
              <a
                href={disclaimerConfig.informationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="disclaimer-information-link"
              >
                {disclaimerConfig.informationLinkText}
              </a>
            )}

            {disclaimerConfig.disclaimerTitle && (
              <h3 className="disclaimer-disclaimer-title">
                {disclaimerConfig.disclaimerTitle}
              </h3>
            )}
            {disclaimerConfig.disclaimerText && (
              <div className="disclaimer-disclaimer-text">
                {disclaimerConfig.disclaimerText.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            )}
          </div>

          <div className="disclaimer-button-container">
            <button
              type="button"
              onClick={handleAccept}
              className="disclaimer-accept-button"
            >
              {disclaimerConfig.acceptButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
